import AdminIcon from './component'

export default AdminIcon
